import React from "react";
import PropTypes from "prop-types";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

function TableHeader({ headers }) {
  return (
    <thead className="bg-gradient-to-r from-gray-800 via-gray-700 to-gray-800">
      <tr>
        {headers.map((header, index) => (
          <th
            key={`header-${header.id}`}
            className={`group relative px-8 py-6 text-sm font-bold uppercase tracking-wide text-gray-200 ${
              index === 0 ? "text-left" : "text-center"
            }`}
          >
            <div className={`flex items-center space-x-2 ${index === 0 ? "" : "justify-center"}`}>
              <span className="whitespace-nowrap text-white">{header.label}</span>
              {header.tooltip && (
                <div className="relative">
                  <InformationCircleIcon className="size-4 cursor-help text-gray-400 transition-colors duration-200 hover:text-blue-400" />
                  <div className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-3 -translate-x-1/2 opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                    <div className="whitespace-nowrap rounded-lg border border-gray-600 bg-gray-800 px-4 py-3 text-xs text-gray-200 shadow-xl backdrop-blur-sm">
                      {header.tooltip}
                      <div className="absolute left-1/2 top-full -translate-x-1/2 border-4 border-transparent border-t-gray-800" />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
}

TableHeader.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
    }),
  ).isRequired,
};

export default TableHeader;
